import React from "react";
import { useTranslation } from "react-i18next";
import { cleanSources } from "@seo/sources";
import "./content.css";

// "Sources": the laws and official pages a guide is based on, as outbound
// links. The same validation as the server renderer (@seo/sources): only
// http(s) URLs, anything else is dropped.
export default function SourcesBlock({ sources }) {
  const { t } = useTranslation();
  const list = cleanSources(sources);
  if (list.length === 0) return null;
  return (
    <section className="avc-sources" aria-labelledby="avc-sources-title">
      <h2 className="avc-sources__title" id="avc-sources-title">
        {t("sources_title")}
      </h2>
      <ol className="avc-sources__list">
        {list.map((source) => (
          <li key={source.url} className="avc-sources__item">
            <a
              href={source.url}
              target="_blank"
              rel="noopener"
              className="avc-sources__link"
              hrefLang={source.lang || undefined}
            >
              <span lang={source.lang || undefined} dir="auto">
                {source.title}
              </span>
              {/* .avc-sr-only lives in assets/loader.css, loaded on every page. */}
              <span className="avc-sr-only"> {t("sources_new_tab")}</span>
            </a>
            {source.publisher && (
              // <bdi>: a Latin publisher under an Arabic page keeps the page's alignment.
              <span className="avc-sources__publisher">
                <bdi>{source.publisher}</bdi>
              </span>
            )}
          </li>
        ))}
      </ol>
    </section>
  );
}
